import { useReducer, useCallback } from "react";

const defaultDropDownItem = {
    key: '',
    value: ''
}

const ReducerFunc = (state, action) => {
    if (action.type === 'SET_DROPDOWN_OBJECT') {
        return { ...state, dropDownObj: action.dropDownObj }
    }
    if (action.type === 'SET_DROPDOWN_ITEM') {
        return { ...state, selectedItem: action.selectedItem }
    }
    if (action.type === 'SET_SELECTED_DROPDOWN_ITEM_VALUE') {
        const selectedDropDownItemCopy = JSON.parse(JSON.stringify(state.selectedItem))
        selectedDropDownItemCopy.key = action.value
        selectedDropDownItemCopy.value = action.value

        return { ...state, selectedItem: selectedDropDownItemCopy }
    }
    if (action.type === 'DELETE_DROPDOWN_ITEM') {
        const dropDownObjCopy = JSON.parse(JSON.stringify(state.dropDownObj))
        const dropDownItemsCopy = dropDownObjCopy.dropDownItems
        const dropDownItemIndex = dropDownItemsCopy.findIndex(dropDownItem => dropDownItem.value === action.selectedItem.value)
        if (dropDownItemIndex > -1) {
            dropDownItemsCopy.splice(dropDownItemIndex, 1)
        }
        return { ...state, dropDownObj: dropDownObjCopy, selectedItem: defaultDropDownItem }
    }
    if (action.type === 'INSERT_DROPDOWN_ITEM') {
        const dropDownObjCopy = JSON.parse(JSON.stringify(state.dropDownObj))
        const dropDownItemsCopy = dropDownObjCopy.dropDownItems
        dropDownItemsCopy.push(action.selectedItem)

        return { ...state, dropDownObj: dropDownObjCopy, selectedItem: defaultDropDownItem }
    }
    if (action.type === 'SET_DROPDOWN_NAME') {
        const dropDownObjCopy = JSON.parse(JSON.stringify(state.dropDownObj))
        dropDownObjCopy.name = action.name
        return { ...state, dropDownObj: dropDownObjCopy }
    }
    if (action.type === 'RESET_DROPDOWN') {
        return action.initState
    }
    return state
}


const useDropDown = (dropDownCategoryName) => {
    const defaultDropDown = {
        name: dropDownCategoryName,
        category: dropDownCategoryName,
        dropDownItems: [defaultDropDownItem]
    }

    const editDropDownReducerInitState = {
        dropDownObj: defaultDropDown,
        selectedItem: defaultDropDownItem
    }

    const [dropDownState, dropDownDispatch] = useReducer(ReducerFunc, editDropDownReducerInitState)

    const setDropDownObj = useCallback((dropDownObj) => {
        dropDownDispatch({
            type: 'SET_DROPDOWN_OBJECT',
            dropDownObj: dropDownObj
        })

    }, [])

    const setDropDownSelectedItem = useCallback((selectedItem) => {
        dropDownDispatch({
            type: 'SET_DROPDOWN_ITEM',
            selectedItem: selectedItem
        })
    }, [])

    const initDropDown = useCallback((dropDownObj) => {
        dropDownObj.dropDownItems.unshift(defaultDropDownItem)
        setDropDownObj(dropDownObj)
        setDropDownSelectedItem(dropDownObj.dropDownItems[0])
    }, [setDropDownObj, setDropDownSelectedItem])

    const setDropDownItemName = useCallback((value) => {
        dropDownDispatch({
            type: 'SET_SELECTED_DROPDOWN_ITEM_VALUE',
            value
        })
    }, [])

    const deleteDropDownItem = useCallback((dropDownItem) => {
        dropDownDispatch({
            type: 'DELETE_DROPDOWN_ITEM',
            selectedItem: dropDownItem
        })
    }, [])

    const saveDropDownItem = useCallback((dropDownItem) => {
        dropDownDispatch({
            type: 'INSERT_DROPDOWN_ITEM',
            selectedItem: dropDownItem
        })
    }, [])

    const setDropDownName = useCallback((dropDownName) => {
        dropDownDispatch({
            type: 'SET_DROPDOWN_NAME',
            name: dropDownName
        })
    }, [])

    const resetDropDown = useCallback(() => {
        dropDownDispatch({
            type: 'RESET_DROPDOWN',
            initState: editDropDownReducerInitState
        })
    }, [])

    return {
        dropDownObj: dropDownState.dropDownObj,
        dropDownItem: dropDownState.selectedItem,
        initDropDown,
        setDropDownObj,
        setDropDownSelectedItem,
        setDropDownItemName,
        deleteDropDownItem,
        saveDropDownItem,
        setDropDownName,
        resetDropDown
    }

}
export default useDropDown